import { render } from "./EditorInput.vue?vue&type=template&id=c3960cce&ts=true"
import script from "./EditorInput.vue?vue&type=script&lang=ts"
export * from "./EditorInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__